import { useMemo } from 'react';
import { useSelector } from 'react-redux';

 
import {
  getAppChainId,
  getEnvironment,
  getEnvironments,
} from '../redux/selectors';

export function useEnv() {
  const env = useSelector(getEnvironment);
  const envs = useSelector(getEnvironments);
  const appChainId = useSelector(getAppChainId);

  const chainEnv = useMemo(
    () => (env !== undefined ? envs?.[env]?.networks?.[appChainId] : undefined),
    [env, envs, appChainId],
  );

  return {
    envs,
    env,
    chainEnv,
  };
}
